import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import homeLogo from "../../Assets/home-main.svg";
import Tilt from "react-parallax-tilt";
import {
  AiOutlineWhatsApp,
  AiOutlineMail,
  AiFillInstagram,
  AiOutlineInstagram
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            We Value You -
 <span className="purple"> Not Only With Ideas. We Building A </span>Better Relationship.
            </h1>
            <p className="home-about-body">
            We’re a web and mobile apps product development agency with a proven background in
SaaS, Media and Marketing Tech industry.
              <br />
              <br />Whether you’re a startup, an agency or a big company, we’ve got you covered.
              <i>
                <b className="purple">We believe in open communication and collaboration with our clients. We always focused on the best and the latest technologies and business practices that businesses will make profitable. </b>
              </i>
              <br />
              <br />
              Grow More provides a complete range of Web Designing, Web Development,Application Development, E-commerce, Web Application Services. Comand on work, experience, and dedication are the power of characteristics of our team. &nbsp;
              {/* <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Blockchain.
                </b>
              </i> */}
              <br />
              <br />
              {/* Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and */}
              <i>
                <b className="purple">
                  {" "}
                  Grow More is a Agency in India We are a startup and founded in 2022 we are focusing on Technology Services.
                </b>
              </i>
              {/* &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i> */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={homeLogo} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND US ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with us
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://api.whatsapp.com/send?phone=6397124401"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineWhatsApp className="xuy" />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:mishrayash3778@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineMail className="xuy"/>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/company/grow-more-developers"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn className="xuy"/>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/growmore_developers/?igshid=OGQ5ZDc2ODk2ZA%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                 <AiOutlineInstagram className="xuy"/>
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://www.instagram.com/soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
